import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useStore } from 'react-redux';
import authenticateUserOAuth from './authenticateUserOAuth';
import { useOAuthState } from './useOAuthState';

export const OAuthHandler = () => {
  const { route, asPath, replace, pathname, query } = useRouter();
  const dispatch = useDispatch();
  const { getState } = useStore();
  const [state] = useOAuthState();

  useEffect(() => {
    if (!asPath.startsWith('/auth')) window.localStorage.setItem(state, JSON.stringify(asPath));
  }, [state, asPath]);

  // Might be running this too often with this
  useEffect(() => {
    if (route !== '/auth') {
      authenticateUserOAuth(dispatch, getState);
      if ('loginSuccess' in query) {
        const params = new URLSearchParams(query as Record<string, string>);
        params.delete('loginSuccess');
        replace({ pathname, query: params.toString() }, undefined, { shallow: true });
      }
    }
  }, [route, dispatch, getState, replace, pathname, query]);

  return null;
};
